import { Flag, Icon } from "semantic-ui-react";
import { useAppContext } from "./AppContext";



const TextAndIcon = ({text, icon, flag=false}) => {
    const {rtl} = useAppContext();

    return(
        !rtl?(
            <>
            {flag?(<Flag name={icon}/>):(<Icon name={icon}/>)}
            {text}
            </>
        ):(
            <>
            {text}
            {flag?(<Flag name={icon}/>):(<Icon name={icon}/>)}
            </>
        )
    )
    


}


export default TextAndIcon;